import { createClient } from '@connectrpc/connect'
import { createConnectTransport } from '@connectrpc/connect-web'
import { AiChatService } from '../../../../../proto/_gen/aiChat_connect'
import { StartAiChatSessionRequest } from '../../../../../proto/_gen/aiChat_pb'
import { authenticator } from '../../../../pages/_shared/authService'
import { AiChatEvent, AiChatEventPayload } from 'poc-ai-biz-irdb_domain-model'
import { convertClientInfoToProto } from '../../../../../proto/converters'

declare var IRDB_BACKEND_API_URL: string | undefined

type ClientInfo = Extract<AiChatEventPayload, { type: 'clientInfo' }>

export const useStartAiChatSession = () => {
  const backendApiUrl = IRDB_BACKEND_API_URL
  if (!backendApiUrl) {
    throw new Error('The IRDB_BACKEND_API_URL environment variable is not set')
  }

  const transport = createConnectTransport({
    baseUrl: backendApiUrl,
    interceptors: [authenticator],
  })
  const client = createClient(AiChatService, transport)

  return async (request: { userId: string; initialClientInfo: ClientInfo; userMessage: string | undefined }) => {
    // domain-model型をProtobuf型に変換
    const protoRequest = new StartAiChatSessionRequest({
      userId: request.userId,
      initialClientInfo: convertClientInfoToProto(request.initialClientInfo),
      userMessage: request.userMessage,
    })

    const response = await client.startAiChatSession(protoRequest)

    if (response.error) {
      throw new Error(response.error.message || 'Unknown error occurred during session start')
    }

    if (!response.sessionId) {
      throw new Error('No sessionId returned from server')
    }

    return {
      sessionId: response.sessionId,
    }
  }
}
